/**
 * Unsplash API Integration
 * Direct REST API calls (official SDK is archived but API is active)
 *
 * Free tier: 50 requests/hour
 * Docs: https://unsplash.com/documentation
 */

// TODO: Move to environment variable for production
const UNSPLASH_ACCESS_KEY = 'qVPG59FpBOWPZ0l6efPPah_Ih71xVBLdQY9ls4AeZek';

/**
 * Search Unsplash for images
 * @param {string} query - Search keywords
 * @param {number} perPage - Results per page (max 30)
 * @returns {Promise<Array>} Array of image objects
 */
export const searchImages = async (query, perPage = 12) => {
  if (!query.trim()) return [];

  try {
    const response = await fetch(
      `https://api.unsplash.com/search/photos?query=${encodeURIComponent(query)}&per_page=${perPage}&orientation=landscape`,
      {
        headers: {
          'Authorization': `Client-ID ${UNSPLASH_ACCESS_KEY}`
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Unsplash API error: ${response.status}`);
    }

    const data = await response.json();
    return data.results;

  } catch (error) {
    console.error('Unsplash search error:', error);
    return [];
  }
};

/**
 * Get a random photo from Unsplash
 * @param {string} query - Optional topic
 * @returns {Promise<Object|null>} Single image object
 */
export const getRandomPhoto = async (query = '') => {
  try {
    const url = query
      ? `https://api.unsplash.com/photos/random?query=${encodeURIComponent(query)}&orientation=landscape`
      : `https://api.unsplash.com/photos/random?orientation=landscape`;

    const response = await fetch(url, {
      headers: {
        'Authorization': `Client-ID ${UNSPLASH_ACCESS_KEY}`
      }
    });

    if (!response.ok) throw new Error('API error');
    return await response.json();

  } catch (error) {
    console.error('Random photo error:', error);
    return null;
  }
};

const unsplashService = {
  searchImages,
  getRandomPhoto,
};

export default unsplashService;
